import React, { useEffect } from 'react';
import BuildingInfo from './BuildingInfo';

const Contractors = () => {
    return <BuildingInfo type='Contractor'/>;
};

export default Contractors;
